import { computed, makeAutoObservable } from 'mobx';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { AutomaticWithdrawalState } from 'src/AppState/AutomaticWithdrawalState';
import { WithdrawalState } from 'src/AppState/WithdrawalState';
import { Value } from 'src_common/common/mobx-utils/Value';
import { timeout } from 'src_common/common/mobx-utils/timeout';
import { TrpcClient } from 'src/AppState/TrpcClient';
import { ChannelType, NotificationsCountItemType } from 'src_server/trpc/fraudAndCompliance';

export interface TabDetailsType {
    id: string;
    label: string;
    counter: number;
    onClick: () => void;
}

export class FraudAndComplianceState {
    public readonly notificationsCount: Value<Array<NotificationsCountItemType> | null>;

    public constructor(
        public readonly configState: ConfigState,
        public readonly automaticWithdrawalState: AutomaticWithdrawalState,
        public readonly withdrawalState: WithdrawalState,
        private readonly trpc: TrpcClient
    ) {
        this.notificationsCount = new Value<Array<NotificationsCountItemType> | null>(null, (setValue) => {
            const flags: { active: boolean } = { active: true };

            (async (): Promise<void> => {
                while (flags.active) {
                    const response = await this.trpc.client.fraudAndCompliance.getCounters.query();

                    if (response.type === 'ok') {
                        setValue(response.data);
                    } else {
                        console.error(response.message);
                    }

                    if (this.configState.config.withdrawalsTabsShow) {
                        await this.automaticWithdrawalState.refresh();
                        await this.withdrawalState.refresh();
                    }

                    await timeout(30000);
                }
            })().catch((error) => {
                console.error('FraudAndComplianceState', error);
            });

            return (): void => {
                flags.active = false;
            };
        });
        makeAutoObservable(this);
    }

    @computed public get manualWithdrawalsNotificationsCount(): number {
        const listLength = this.automaticWithdrawalState.allList?.length;
        if (listLength !== undefined) {
            return listLength;
        }
        return 0;
    }

    @computed public get automaticWithdrawalsNotificationsCount(): number {
        return this.automaticWithdrawalState.numberOfPending;
    }

    @computed public get notificationsCountList(): Array<NotificationsCountItemType> | null {
        const responseResource = this.notificationsCount.getValue();
        if (responseResource !== null) {
            return responseResource;
        }
        return null;
    }
    public findCount = (channel: ChannelType): number => {
        const item = this.notificationsCountList?.find((notifications) => notifications.channel === channel);
        return item?.count ?? 0;
    };
}
